import { defineMessages } from 'react-intl'

export default defineMessages({
  logToAccount: {
    id: 'containers.UserSignIn.components.SignIn.logToAccount',
    defaultMessage: 'Log in to your account',
  },
  username: {
    id: 'containers.UserSignIn.components.SignIn.username',
    defaultMessage: 'Username',
  },
  password: {
    id: 'containers.UserSignIn.components.SignIn.password',
    defaultMessage: 'Password',
  },
  signIn: {
    id: 'containers.UserSignIn.components.SignIn.signIn',
    defaultMessage: 'Sign in',
  },
  signingIn: {
    id: 'containers.UserSignIn.components.SignIn.signingIn',
    defaultMessage: 'Signing in',
  },
  forgotUser: {
    id: 'containers.UserSignIn.components.SignIn.forgotUser',
    defaultMessage: 'Forgot your username or password?',
  },
  helpAccess: {
    id: 'containers.UserSignIn.components.SignIn.helpAccess',
    defaultMessage: 'Help me access my',
  },
  dashboard: {
    id: 'containers.UserSignIn.components.SignIn.dashboard',
    defaultMessage: 'account',
  },
})
